package com.eladfinish.contract.suggestions

import kotlinx.serialization.Serializable

/**
 * The list of popular search expressions the app suggests while typing. Generated by the server
 * from the search analytics events, published as a static file, downloaded by the app.
 *
 * Entries are sorted by [SearchSuggestionEntry.n] descending, so a prefix match can take the first
 * matches as the best ones.
 */
@Serializable
data class SearchSuggestionsSnapshot(

    /** Format version. Bump when a field changes meaning. */
    val version: Int = FORMAT_VERSION,

    /** When the snapshot was generated, ISO-8601. */
    val generatedAt: String,

    /** Minimum [SearchSuggestionEntry.n] an entry needed to be included. */
    val threshold: Int,

    /** Length of the window [SearchSuggestionEntry.r] counts over, in days. */
    val recentDays: Int,

    val entries: List<SearchSuggestionEntry>,
) {

    companion object {
        const val FORMAT_VERSION = 1
    }
}

@Serializable
data class SearchSuggestionEntry(

    /** The expression exactly as users typed it. Never normalized. */
    val q: String,

    /** Distinct installations that searched [q], all time. */
    val n: Int,

    /** Distinct installations that searched [q] in the last [SearchSuggestionsSnapshot.recentDays] days. */
    val r: Int,

    /** Share of the completed searches of [q] that returned at least one verse, 0.0 to 1.0. */
    val ok: Double,
)
